<div class="metabase-wrapper">
  <iframe
    [src]="sanitizedUrl()"
    title="Dashboard"
    style="flex: 1; border: unset"
  ></iframe>
  <div class="k5-wrapper">
    @if (loadingk5()) {
      <mat-spinner diameter="20" style="margin-right: 8px;"></mat-spinner>
    } @else {
      <button mat-raised-button color="primary" [matMenuTriggerFor]="k5Menu">
        <mat-icon
          svgIcon="{{EsvgFiles.download}}"
          style="display: flex; justify-content: center; align-items: center"
        ></mat-icon>
        K5-Export
      </button>
    }

  </div>
</div>

<mat-menu
  #k5Menu="matMenu"
  xPosition="before"
  class="customized-menu"
>
  <div
    mat-menu-item
    *ngFor="let dateRange of possibleK5Dates"
    (click)="exportK5(dateRange)"
    style="display: flex; flex-direction: row; justify-content: space-between;"
  >
    <span>{{ dateRange.description }}</span>
  </div>
</mat-menu>
